module.exports = __webpack_public_path__ + "components/flag/static/square/ca-2b92a425cae28607b814aec48657d53c.svg";